import { render, staticRenderFns } from "./ViewTaskFile.vue?vue&type=template&id=561bb036"
import script from "./ViewTaskFile.vue?vue&type=script&lang=js"
export * from "./ViewTaskFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports